import { translateText } from '@/locales/text'
export const PERMISSION_ENUM = {
  'add': { key: 'add', get label () { return translateText('新增') } },
  'delete': { key: 'delete', get label () { return translateText('删除') } },
  'edit': { key: 'edit', get label () { return translateText('修改') } },
  'query': { key: 'query', get label () { return translateText('查询') } },
  'get': { key: 'get', get label () { return translateText('详情') } },
  'enable': { key: 'enable', get label () { return translateText('启用') } },
  'disable': { key: 'disable', get label () { return translateText('禁用') } },
  'import': { key: 'import', get label () { return translateText('导入') } },
  'export': { key: 'export', get label () { return translateText('导出') } }
}

/**
 * <a-button v-if="$auth('form.edit')">Button</a-button>
 * @param Vue
 */
function plugin (Vue) {
  if (plugin.installed) {
    return
  }

  !Vue.prototype.$auth && Object.defineProperties(Vue.prototype, {
    $auth: {
      get () {
        const _this = this
        return (permissions) => {
          const [permission, action] = permissions.split('.')
          const permissionList = _this.$store.getters.roles.permissions
          return permissionList.find((val) => {
            return val.permissionId === permission
          }).actionList.findIndex((val) => {
            return val === action
          }) > -1
        }
      }
    }
  })

  !Vue.prototype.$enum && Object.defineProperties(Vue.prototype, {
    $enum: {
      get () {
        // const _this = this;
        return (val) => {
          let result = PERMISSION_ENUM
          val && val.split('.').forEach(v => {
            result = result && result[v] || null
          })
          return result
        }
      }
    }
  })
}

export default plugin
